import {
    RepresentativeData,
    RepresentativeCreateForm,
    RepresentativeUpdateForm,
} from 'chaika-frontend-types/frontend-cms';

import { axios } from '@lib/axios';

const BASE_URL = '/api';

export class RepresentativeApi {
    public static async create(ehrId: string, representative: RepresentativeCreateForm): Promise<void> {
        await axios.post(`${BASE_URL}/ehr/${ehrId}/representative`, { representative });
    }

    public static async update(ehrId: string, id: string, representative: RepresentativeUpdateForm): Promise<void> {
        await axios.put(`${BASE_URL}/ehr/${ehrId}/representative/${id}`, { representative });
    }

    public static async remove(ehrId: string, id: string): Promise<void> {
        await axios.delete(`${BASE_URL}/ehr/${ehrId}/representative/${id}`);
    }

    public static async getEhrRepresentativeList(ehrId: string): Promise<RepresentativeData[]> {
        const res = await axios.get(`${BASE_URL}/ehr/${ehrId}/representative`);

        return res.data.representatives;
    }

    public static async getConfidantList(id: string): Promise<RepresentativeData[]> {
        const res = await axios.get(`${BASE_URL}/representative/${id}`);

        return res.data.representatives;
    }
}
